import { ViewListContext, ViewListData } from "@/context/ViewListContext";
import React, { useEffect, useMemo } from "react";
import { PropsWithChildren } from "react";

export function ViewListItem(props: PropsWithChildren) {
  return <>{props.children}</>;
}

type ViewListProps = PropsWithChildren<ViewListData> & {
  setStepsCount: (count: number) => void;
  content?: React.ReactNode[];
  debug?: string;
};

export function ViewList({ debug, content, children, ...props }: ViewListProps) {
  const { activeStep } = props;

  const steps = useMemo(() => {
    const res = content
      ? [...content]
      : (React.Children.toArray(children).filter(
          (step) => React.isValidElement(step) && step.type === ViewListItem,
        ) ?? []);

    if (import.meta.env.DEV) {
      if (props.hasStartStep) res[-1] = <h1 className="text-destructive">Start of ViewList</h1>;

      if (props.hasEndStep) res.push(<h1 className="text-destructive">End of ViewList</h1>);
    }

    return res;
  }, [content, children]);

  useEffect(() => {
    props.setStepsCount(
      steps.length -
        +(import.meta.env.DEV ? (props.hasEndStep ?? 0) : false) -
        +(import.meta.env.DEV ? (props.hasStartStep ?? 0) : false),
    );
  }, [steps.length]);

  return (
    <ViewListContext.Provider value={props}>
      {steps[Math.min(activeStep, steps.length - 1)]}
    </ViewListContext.Provider>
  );
}

export default ViewList;
